// 导入所有接口
import apis from './api'
import apis1 from './api1'

const install = Vue => {
  if (install.installed)
    return;

  install.installed = true;

  Object.defineProperties(Vue.prototype, {
    // 注意，此处挂载在 Vue 原型的 $api 对象上
    $api: {
      get() {
        return apis
      }
    },
    
  })
  Object.defineProperties(Vue.prototype, {
    // 注意，此处挂载在 Vue 原型的 $api 对象上
    $api1: {
      get() {
        return apis1
      }
    },
    
  })
}

export default install


// WEBPACK FOOTER //
// ./src/http/index.js